import { FC } from 'react';

const TripBuilderGetPdfStylesV2: FC = () => {
  return (
    <style>{`
.tbp-root-v2 {
  --tbp-flight-accent: #5ec9db;
  --tbp-tag-room-bg: #dff4f8;
  --tbp-tag-room-text: #3d8fa0;
  --tbp-tag-board-bg: #e7f6ec;
  --tbp-tag-board-text: #4f8a62;
  --tbp-tag-cxl-bg: #faf0e8;
  --tbp-tag-cxl-text: #9a6b45;
  --tbp-warm: #1a1a1a;
  font-family: 'Assistant', 'Heebo', 'Source Sans 3', Arial, sans-serif;
  color: #1a1a1a;
}

.tbp-root-v2 .tbp-section-label {
  display: block;
  margin-bottom: 16px;
  font-family: inherit;
  font-size: 1.75rem;
  font-weight: 700;
  letter-spacing: normal;
  text-transform: none;
  color: #1a1a1a;
}

.tbp-root-v2 .tbp-section-label::before {
  display: none;
}

.tbp-root-v2 .tbp-destination-block {
  border: 2px solid #d8d8d8;
  border-radius: 14px;
}

.tbp-root-v2 .tbp-destination {
  border-bottom-color: #ececec;
}

.tbp-root-v2 .tbp-destination-divider {
  background: #ececec;
}

.tbp-root-v2 .tbp-destination-separator::before {
  background: #d8d8d8;
}

.tbp-root-v2 .tbp-destination-city {
  font-family: inherit;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
}

.tbp-root-v2 .tbp-destination-index {
  border-color: #5ec9db;
  color: #1a1a1a;
  font-family: inherit;
}

.tbp-root-v2 .tbp-destination-meta {
  font-family: inherit;
  color: #666;
}

.tbp-root-v2 .tbp-option-card {
  border-top: 1px solid #ececec;
}

.tbp-root-v2 .tbp-option-card-img {
  flex: 0 0 64px;
  width: 64px;
  height: 64px;
  border: 1px solid #ececec;
}

.tbp-root-v2 .tbp-option-card-name {
  font-family: inherit;
  font-size: 1rem;
  font-weight: 700;
  color: #1a1a1a;
  direction: ltr;
  text-align: left;
}

.tbp-root-v2 .tbp-option-tag {
  font-family: inherit;
  font-size: 0.6875rem;
  font-weight: 600;
}

.tbp-root-v2 .tbp-option-tag-room {
  padding: 0;
  margin-inline-end: 4px;
  border-radius: 0;
  background: none;
  color: #1a1a1a;
  font-size: 0.875rem;
  font-weight: 700;
}

.tbp-root-v2 .tbp-option-tag-cxl-danger {
  background: #c01f2f;
  color: #fff;
}

.tbp-root-v2 .tbp-option-tag-cxl-success {
  background: #366e34;
  color: #fff;
}

.tbp-root-v2 .tbp-option-meta {
  font-family: inherit;
  color: #666;
}

.tbp-root-v2 .tbp-option-price {
  font-family: inherit;
  font-size: 1.25rem;
  font-weight: 700;
  color: #1a1a1a;
}

.tbp-root-v2 .tbp-option-price .tbp-price-currency,
.tbp-root-v2 .tbp-option-price .tbp-price-value {
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
}

.tbp-root-v2 .tbp-option-price .tbp-price-currency {
  font-size: 0.8em;
}

.tbp-root-v2 .tbp-option-price .tbp-price-value {
  font-size: inherit;
}

.tbp-root-v2 .tbp-option-price-sub {
  font-family: inherit;
  color: #666;
}

.tbp-root-v2 .tbp-flight-card {
  border: 2px solid #5ec9db;
  border-radius: 10px;
  background: #f7fdfe;
}

.tbp-root-v2 .tbp-flight-row-codes > span:first-child,
.tbp-root-v2 .tbp-flight-row-codes > span:last-child {
  font-family: inherit;
  font-weight: 700;
}

.tbp-root-v2 .tbp-flight-row-labels span,
.tbp-root-v2 .tbp-flight-row-title {
  font-family: inherit;
}

.tbp-root-v2 .tbp-route-summary {
  background: #dff4f8;
}

.tbp-root-v2 .tbp-route-summary-label {
  font-family: inherit;
  font-weight: 700;
}

.tbp-root-v2 .tbp-total-label {
  font-family: inherit;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #666;
}

.tbp-root-v2 .tbp-total-amount {
  font-family: inherit;
  font-size: 2rem;
  font-weight: 700;
  color: #1a1a1a;
}

.tbp-root-v2 .tbp-total-amount .tbp-price-currency,
.tbp-root-v2 .tbp-total-amount .tbp-price-value {
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
}

.tbp-root-v2 .tbp-total-amount .tbp-price-currency {
  font-size: 0.8em;
}

.tbp-root-v2 .tbp-total-amount .tbp-price-value {
  font-size: inherit;
}

.tbp-root-v2 .tbp-flight-price {
  font-family: inherit;
  font-size: 0.875rem;
  font-weight: 700;
  color: #1a1a1a;
}

.tbp-root-v2 .tbp-flight-price .tbp-price-currency,
.tbp-root-v2 .tbp-flight-price .tbp-price-value {
  font-family: inherit;
  font-weight: inherit;
  color: inherit;
}

.tbp-root-v2 .tbp-flight-price .tbp-price-currency {
  font-size: 0.8em;
}

.tbp-root-v2 .tbp-flight-price .tbp-price-value {
  font-size: inherit;
}

.tbp-root-v2[dir="rtl"] .tbp-option-card-name {
  direction: rtl;
  text-align: right;
}
    `}</style>
  );
};

export default TripBuilderGetPdfStylesV2;
